// Continuous warm → cool spectrum matching How to Play / medal language.
export function rankAccent(rank: number): string {
  if (rank >= 90) return '#22d3ee';
  if (rank >= 76) return '#2dd4bf';
  if (rank >= 60) return '#4ade80';
  if (rank >= 40) return '#a3e635';
  if (rank >= 26) return '#facc15';
  if (rank >= 11) return '#fb923c';
  return '#f97316';
}

export const RANK_SPECTRUM =
  'linear-gradient(to right, #f97316, #fb923c, #facc15, #a3e635, #4ade80, #2dd4bf, #22d3ee)';

export const RANK_ZONES = [
  { id: 'obvious', label: 'The Obvious', from: 1, to: 25, accent: '#fb923c' },
  { id: 'familiar', label: 'The Familiar', from: 26, to: 50, accent: '#facc15' },
  { id: 'solid', label: 'Solid Territory', from: 51, to: 75, accent: '#4ade80' },
  { id: 'deep', label: 'Deep Cuts', from: 76, to: 100, accent: '#22d3ee' },
] as const;
